import React, { useState } from "react";
import {Button, Form, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import AuthService from "../services/AuthService";
import {
    useHistory
  } from 'react-router-dom';
export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  let history = useHistory();
  function validateForm() {
    return username.length > 0 && password.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();

    AuthService.login(username, password).then(
        () => {
          history.push("/");
          window.location.reload();
        },
        (error) => {
          console.log('error ', error);
        }
      );
  }

  return (
    <div className="Login">
      <span style={{textAlign: 'center'}}><h1>Voting Booth</h1></span>
      <div className={'col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 main-text-area'}>
      <Form onSubmit={handleSubmit}>
        <FormGroup size="lg" controlId="username">
          <ControlLabel>Username</ControlLabel>
          <FormControl
            autoFocus
            type="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </FormGroup>
        <FormGroup size="lg" controlId="password">
          <ControlLabel>Password</ControlLabel>
          <FormControl
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormGroup>
        <div style={{marginLeft: '20px'}}>
        <Button block size="lg" type="submit" disabled={!validateForm()}>
          Login
        </Button>
        </div>
      </Form>
      </div>
    </div>
  );
}